// extracted by css-extract-rspack-plugin
export default {"root":"root-zBm6pB","svg":"svg-o6XpZd","svgwhite":"svgwhite-alEcKK","slotTargetPopover":"slotTargetPopover-TVAMMp"};